import { useState } from "react"
import { Box, Button } from "@mui/material"
import "./index.css" // Renamed to a more generic name
import { emailValidateRegex } from "../../utils/Helpers"
import Loader from "../GlobalComponents/Loader"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { FormField } from "../GlobalComponents/Fields"
import { showToast } from "../GlobalComponents/Toast"
import { forgotPassword } from "../../services/services"

function ForgotPassword() {
  const [userName, setUserName] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const enableLogin = emailValidateRegex.test(userName)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    const data = await forgotPassword({ email: userName })
    console.log("data", data)
    if (data?.status !== "Success") {
      let message = data.message
      showToast("error", message)
    } else {
      navigate("/otpScreen", { state: { email: userName } })
    }

    setIsLoading(false)
  }

  return (
    <Box className="login-wrapper">
      <Box className="login-container">
        {/* Left Sidebar with Background */}
        <Box className="sidebar-container" />

        {/* Login Form */}
        <Box className="form-container">
          {isLoading && <Loader />}
          <form onSubmit={handleSubmit} className="login-form">
            <Button className="back_button_top" onClick={() => navigate("/")}>
              <ArrowBackIcon className="back_icon" />
              <span className="backBtn">Back</span>
            </Button>
            <h1 className="form-header">Forgot Password</h1>
            <p className="auth_description">Please provide your Email to continue</p>

            <FormField
              label="Email"
              name="Email"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Email"
            />

            <Button
              type="submit"
              variant="contained"
              className="submit-button"
              disabled={!enableLogin}
              sx={!enableLogin && { color: "gray" }}
            >
              Submit
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  )
}

export default ForgotPassword
